import React from "react";

const EmployeeDiscountPrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-40">
      <h1 className="text-3xl font-bold mb-6">
        Privacy Policy for Employee Discount App
      </h1>

      <p className="mb-6">
        This Privacy Policy outlines how we collect, use, and protect your
        information when you use our App.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        1. Information We Collect
      </h2>

      <h3 className="text-xl font-medium mb-2">
        1.1 Information from Merchants
      </h3>
      <p className="mb-2">
        When you install and use the App, we collect the following data from
        your Shopify store:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Store name and URL</li>
        <li>Store owner’s email address</li>
        <li>Employee account details (to manage assigned discounts)</li>
        <li>Order and checkout details (to apply discounts correctly)</li>
      </ul>

      <h3 className="text-xl font-medium mb-2">
        1.2 Information from Employees
      </h3>
      <p className="mb-2">
        For employees using the App, we collect:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Employee email (for discount allocation)</li>
        <li>
          Assigned discount details (discount type, value, usage limits)
        </li>
        <li>
          Order and checkout information (to process discounts)
        </li>
      </ul>

      <p className="mb-6">
        <strong>Note:</strong> We do not collect passwords, payment details, or
        sensitive personal information.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        2. How We Use Your Information
      </h2>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Provide and manage employee discount allocations</li>
        <li>Allow employees to redeem discounts at checkout</li>
        <li>
          Monitor and enforce discount policies set by the merchant
        </li>
        <li>Improve the App’s functionality and user experience</li>
        <li>Respond to support requests</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        3. Sharing of Information
      </h2>
      <p className="mb-2">
        We do not sell or share your information with third parties except in
        the following cases:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          <strong>Shopify:</strong> To integrate and operate the App within
          your Shopify store.
        </li>
        <li>
          <strong>Legal Compliance:</strong> If required by law, court order,
          or governmental authority.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        4. Data Security
      </h2>
      <p className="mb-6">
        We implement strict security measures to protect your data, including
        encryption, secure access controls, and compliance with Shopify’s
        security standards.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        5. Data Retention
      </h2>
      <p className="mb-6">
        We retain merchant and employee data only as long as necessary to
        provide the App’s services. If a merchant uninstalls the App, we delete
        all related data within 30 working days unless legally required to
        retain it.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        6. Your Rights
      </h2>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Access, update, or delete their stored data</li>
        <li>Request information about how their data is used</li>
        <li>Withdraw consent for data collection and processing</li>
      </ul>
      <p className="mb-6">
        To exercise these rights, contact us at{" "}
        <a
          href="mailto:support@mean3.com"
          className="text-blue-500 hover:underline"
        >
          support@mean3.com
        </a>
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        7. Third-Party Services
      </h2>
      <p className="mb-6">
        Our App integrates with Shopify and relies on their infrastructure.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        8. Changes to This Privacy Policy
      </h2>
      <p className="mb-6">
        We may update this policy periodically. Any changes will be posted here
        with the updated effective date. Continued use of the App after updates
        means acceptance of the revised policy.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        9. Contact Us
      </h2>
      <p className="mb-2">
        If you have any questions about this Privacy Policy or your data
        rights, please contact us at:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          <strong>Support Email:</strong>{" "}
          <a
            href="mailto:support@mean3.com"
            className="text-blue-500 hover:underline"
          >
            support@mean3.com
          </a>
        </li>
      </ul>
    </div>
  );
};

export default EmployeeDiscountPrivacyPolicy;